module.exports = __webpack_public_path__ + "img/valuationResultFont.c4d753a9.svg";